import { evaluateConnection } from '../../ProjectPackage/utils/validate';

/**
 * Visual state for a port while a connection is being dragged.
 * @returns {'idle' | 'origin' | 'compatible' | 'incompatible'}
 */
export function handleDragHighlight({
  connectionNodeId,
  connectionHandleId,
  connectionHandleType,
  handleNodeId,
  handleId,
  handleType,
  nodes,
}) {
  if (!connectionNodeId || !connectionHandleType) {
    return 'idle';
  }

  if (
    handleNodeId === connectionNodeId &&
    handleId === connectionHandleId &&
    handleType === connectionHandleType
  ) {
    return 'origin';
  }

  let source;
  let target;
  let sourceHandle;
  let targetHandle;
  if (connectionHandleType === 'source') {
    if (handleType !== 'target') return 'incompatible';
    source = connectionNodeId;
    sourceHandle = connectionHandleId;
    target = handleNodeId;
    targetHandle = handleId;
  } else {
    if (handleType !== 'source') return 'incompatible';
    source = handleNodeId;
    sourceHandle = handleId;
    target = connectionNodeId;
    targetHandle = connectionHandleId;
  }

  const sourceNode = nodes.find((node) => node.id === source);
  const targetNode = nodes.find((node) => node.id === target);
  const result = evaluateConnection({
    sourceNode,
    targetNode,
    sourceHandle,
    targetHandle,
  });
  return result.valid ? 'compatible' : 'incompatible';
}
